export const PROJECT = 'PROJECT'
